import React, {FC, useState} from "react";
import {StyledButton, StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useConsumerSendMailMutation, usePublicPageConsumerCreateMutation} from "../../Queries";
import {isValidEmail} from "../../components/Validations";
import clsx from "clsx";
import {Theme} from "@mui/material";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {DropOffIcon, PackItIcon, TradeInIcon} from "../../svg/SvgIcons";
import {LocaleAtom, LocalizationsAtom} from "../../providers/localization/LocalizationProvider";
import {TradeInBox} from "./TradeInBox";
import {Images} from "../../Images";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import {CountryMapFactory} from "../../utility/CountryMapFactory";
import {ReturnsPagePath} from "../restricted/returns/ReturnsPage";
import {LoginContext} from "../LoginContext";
import {useNavigate} from "react-router-dom";
import {Dialogs} from "../../Dialog";
import {LocalizationText} from "../../providers/localization/LocalizationText";

export const GaiLisva: FC<any> = () => {
   const [loginType, setLoginType] = useState<'login' | 'wholesale' | undefined>();
   const [email, setEmail] = useState<string>('');
   const localizations = useRecoilValue(LocalizationsAtom);
   const appContext = useRecoilValue(AccessContextData);
   const [register] = usePublicPageConsumerCreateMutation()
   const [sendMail] = useConsumerSendMailMutation();
   const locale = useRecoilValue(LocaleAtom);
   const setLoginContext = useSetRecoilState(LoginContext)
   const navigate = useNavigate();

   const classes = useStyles({
      leftImage: localizations.frontPageImage1 || "url('https://cdn.shopify.com/s/files/1/1308/1119/files/G_L_TradeIn_01.jpg?v=1726590205')",
      rightImage: localizations.frontPageImage2 || "url('https://cdn.shopify.com/s/files/1/1308/1119/files/G_L_TradeIn_02.jpg?v=1726590205')",
   });

   let showLoginOptions = true;

   async function registerNewUser() {
      const countries = CountryMapFactory.getCountriesFromDomain(window.location.hostname)
      const country = countries?.[0]?.alpha2 || 'DK'

      const consumer = await register({
         variables: {
            shopId: appContext.shopId,
            locale: locale,
            country: window.Shopify?.country || window.tradeInSession?.countryCode || country,
            currency: appContext.currency || window.Shopify?.currency?.active || window.tradeInSession?.currency
         }
      });
      if (consumer.data?.ConsumerCreate?.accessToken) {
         setLoginContext({
            accessToken: consumer.data.ConsumerCreate.accessToken
         })
         navigate(ReturnsPagePath());
      }
   }

   const onStart = async () => {
      if (!loginType) {
         return;
      } else if (loginType === 'login') {
         // Handle email sending
         let shopId = window.shopId || window.brandId;
         if (!!email && isValidEmail(email)) {
            await sendMail({
               variables: {
                  shopId: shopId,
                  mail: email
               }
            });
            setLoginType(undefined)
            setEmail('');
            // Show popup
            Dialogs.info({
               title: localizations.mainPageMailSent,
               subtitle: localizations.mainPageMailSent2,
               okayText: 'OK'
            });
         }
      } else if (loginType === 'wholesale') {
         await registerNewUser();
      }
   }

   return <div>
      <StyledDiv type={"main"} className={classes.container}>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.leftImage)}>
            &nbsp;
         </StyledDiv>
         <StyledDiv type={"contrast"} className={classes.main}>
            <div className={classes.content}>

               <StyledTypography variant={"h1"} type={"contrast"} style={{
                  letterSpacing: '3.5px',
                  marginBottom: '26px', color: '#484845'
               }}>
                  {localizations.loginPageTitle}
               </StyledTypography>

               <LocalizationText text={localizations.loginPageDescription}
                                 typographyProps={{variant: "body1"}}
                                 style={{color: '#484845'}}
               />
               <LocalizationText text={localizations.loginPageDescription2}
                                 style={{color: '#484845'}}
                                 typographyProps={{variant: "body1"}}
               />
               {showLoginOptions && <div className={classes.tradeInBoxContainer}>
                  <TradeInBox id={"login"} title={localizations.publicPageLoginTitle}
                              description={localizations.publicPageLoginDescription}
                              onClick={() => {
                                 const element = document.getElementById('loginemail');
                                 element?.removeAttribute('disabled');
                                 element?.focus();
                                 setLoginType("login");
                              }}
                              image={Images.TRADEIN_DTC}
                              selected={loginType === 'login'}
                              disableIcons={true}
                              sx={{}}
                  >
                     <form onSubmit={async (e) => {
                        e.preventDefault();
                        await onStart();
                     }}>
                        <input
                           style={{
                              minWidth: "150px",
                              width: '100%',
                              pointerEvents: loginType !== 'login' ? 'none' : 'auto'
                           }}
                           className={clsx("input", classes.emailInput)}
                           id="loginemail"
                           type="email"
                           value={email}
                           disabled={loginType !== 'login'}
                           onChange={(event) => {
                              setEmail(event.target.value);
                           }}
                           placeholder={localizations.mainPageEnterEmail}
                           aria-haspopup={false}
                           autoComplete={"off"}
                           required
                           autoCorrect="off"
                           autoCapitalize="off"
                        />
                     </form>
                  </TradeInBox>
                  <TradeInBox id={"wholesale"} title={localizations.publicPageWholeSaleTitle}
                              description={localizations.publicPageWholeSaleDescription}
                              onClick={() => setLoginType("wholesale")}
                              disableIcons={true}
                              image={Images.TRADEIN_RETAILER}
                              selected={loginType === 'wholesale'}
                  />
               </div>}
               <div className={classes.buttonContainer}>
                  <StyledButton disabled={showLoginOptions && !loginType} styletype={"front"} className={classes.button}
                                onClick={onStart}>
                     {localizations.publicPagePageStartButton}
                  </StyledButton>
               </div>
            </div>
         </StyledDiv>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.rightImage)}>
            &nbsp;
         </StyledDiv>
      </StyledDiv>
      <GaiLisvaEasyBox/>
   </div>
}

type imageProps = {
   leftImage: string
   rightImage: string
}

const useStyles = makeStyles({
   title: {
      marginBottom: '20px'
   },
   tradeInBoxContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      margin: '20px auto 0 auto',
      maxWidth: '600px'
   },
   buttonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   button: {
      marginTop: '25px',
      width: '250px',
      marginBottom: '0px',
      letterSpacing: '3.5px',
      textTransform: 'uppercase'
   },
   emailInput: {
      transition: 'background-color 0.2s ease',
      letterSpacing: '3.5px',
      position: 'relative' as const,
      zIndex: 1,
      isolation: 'isolate',
      '&:disabled': {
         backgroundColor: '#f5f5f5 !important',
         opacity: 1,
         WebkitTextFillColor: '#484845 !important',
         color: '#484845 !important'
      },
      '&:not(:disabled)': {
         backgroundColor: '#fff !important', // White when enabled (selected)
      },
      '&:focus': {
         backgroundColor: '#fff !important' // White when focused
      },
      '&:-webkit-autofill:disabled': {
         WebkitBoxShadow: '0 0 0px 1000px #f5f5f5 inset !important',
         boxShadow: '0 0 0px 1000px #f5f5f5 inset !important',
         WebkitTextFillColor: '#484845 !important'
      },
      '&:-webkit-autofill:not(:disabled)': {
         WebkitBoxShadow: '0 0 0px 1000px #fff inset !important',
         boxShadow: '0 0 0px 1000px #fff inset !important',
         WebkitTextFillColor: '#484845 !important'
      },
      '&:-webkit-autofill:focus': {
         WebkitBoxShadow: '0 0 0px 1000px #fff inset !important',
         boxShadow: '0 0 0px 1000px #fff inset !important',
         WebkitTextFillColor: '#484845 !important'
      }
   },
   backContainer: {
      marginTop: '20px'
   },
   content: {
      maxWidth: '800px',
      textAlign: 'center'
   },
   container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'top',
      padding: '0'
   },
   accessForm: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
   },
   image: {
      width: '400px',
      minHeight: '496px',
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "top center",
      overflowX: 'hidden',
      overflowY: 'hidden',
   },
   main: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      padding: '40px'
   },
   leftImage: {
      backgroundImage: (props: imageProps) => props.leftImage
   },
   rightImage: {
      backgroundImage: (props: imageProps) => props.rightImage
   },
   '@media only screen and (max-width: 800px)': {
      container: {
         flexDirection: 'column',
         padding: '0 23px 0 23px'
      } as any,
      image: {
         width: '100%',
         maxHeight: '200px',
         minHeight: '300px',
         backgroundPosition: "center",
      },
      buttonContainer: {
         alignItems: 'center',
         justifyContent: 'center'
      },
   },
   '@media only screen and (max-width: 1024px)': {
      container: {
         padding: '0 23px 0 23px'
      } as any
   },
})


const GaiLisvaEasyBox = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useEasyStyles();
   return <div className={classes.container}>
      <div>
         <StyledTypography variant={"h1"} className={classes.title}>
            {localizations.easyBoxTitle}
         </StyledTypography>
      </div>
      <div>
         <div className={classes.list}>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <TradeInIcon type={"main"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection1Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection1Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <PackItIcon type={"main"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection2Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection2Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <DropOffIcon type={"main"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection3Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection3Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <img src={localizations.easyBoxSection4Icon} style={{width: '45px', height: '45px'}}
                       title={localizations.easyBoxSection4Title} alt={localizations.easyBoxSection4Title}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection4Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection4Description}
                  </StyledTypography>
               </div>
            </div>
         </div>
      </div>
   </div>
}


const useEasyStyles = makeStyles((theme: Theme) => ({
      container: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center'
      },
      title: {
         marginTop: '40px',
         letterSpacing: '3.5px'
      },
      text: {
         marginBottom: '15px',
         letterSpacing: '3.5px'
      },
      list: {
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         marginTop: '40px'
      },
      listItem: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         marginBottom: '20px',
         gap: '10px'
      },
      listAvatar: {},
      listText: {
         marginTop: '0',
         textAlign: 'center',
         maxWidth: '400px',
         padding: '0 20px 0 20px'
      },
      '@media only screen and (max-width: 800px)': {
         list: {
            flexDirection: 'column',
         },
         listItem: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '600px',
            gap: '10px'
         },
      }
   }),
);
